/**
 * Stricter email checks for the admin authorized sign-in whitelist.
 * Keep in sync with inventory-manager-backend
 * `common/validators/admin-whitelist-email.ts`.
 */
export function isValidAdminWhitelistEmail(email) {
  const normalized = String(email || '')
    .trim()
    .toLowerCase()
  if (!normalized) return false

  if (/\s/.test(normalized)) return false

  // Basic shape before deeper checks
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)) return false

  if (normalized.includes('..')) return false

  const at = normalized.lastIndexOf('@')
  const local = normalized.slice(0, at)
  const domain = normalized.slice(at + 1)

  if (!local || !domain) return false
  if (/^[.-]|[.-]$/.test(local)) return false

  const labels = domain.split('.')
  if (labels.length < 2) return false

  for (const label of labels) {
    if (!label) return false
    if (/^[.-]|[.-]$/.test(label)) return false
  }

  const tld = labels[labels.length - 1]
  if (!/^[a-z]{2,}$/i.test(tld)) return false

  if (domain === 'localhost' || domain.startsWith('localhost.')) return false

  return true
}
